import { compose } from 'recompose';

import CategoryCreate from './CategoryCreate';

const enhance = compose();

export default enhance(CategoryCreate);
